var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarried(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75,9.86a2.64,2.64,0,1,1,2.7-1.39,1.84,1.84,0,0,0,1.35.67A4.12,4.12,0,0,0,6,3.6a3.25,3.25,0,0,0-.4-.15l.74-.86a1.27,1.27,0,0,0,.18-1.34,1.07,1.07,0,0,0-1-.64H2.71a1.05,1.05,0,0,0-1,.64,1.23,1.23,0,0,0,.18,1.34l.73.85a4.06,4.06,0,0,0-2.2,2A4.12,4.12,0,0,0,2.26,11a4.17,4.17,0,0,0,1.86.44,4,4,0,0,0,1-.12A4.78,4.78,0,0,1,3.75,9.86Zm-1-8.25,2.89.06a.27.27,0,0,1,0,.27L4.5,3.18a3.86,3.86,0,0,0-.76,0L2.67,1.94A.27.27,0,0,1,2.71,1.61Zm7,2a4.06,4.06,0,0,0-1.87-.45,4,4,0,0,0-1,.12A4.94,4.94,0,0,1,8.25,4.69a2.63,2.63,0,1,1-2.7,1.38A1.83,1.83,0,0,0,4.2,5.41,4.12,4.12,0,1,0,9.74,3.6Z",
    fill: "#ef5323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarried);
export default __webpack_public_path__ + "static/media/married.54b0e944445098205fcb0747c6fb4bc5.svg";
export { ForwardRef as ReactComponent };